import { FEATURE_FLAGS } from '../config/featureFlags';

export const logDebug = (...args: unknown[]) => {
  if (FEATURE_FLAGS.LOG) {
    console.log(...args);
  }
};
